import { useNavigate } from "react-router";
import { MdOutlineLogout } from "react-icons/md";
import { LuChevronRight, LuSunMoon } from "react-icons/lu";
import { getUser } from "~/lib/session";
import { useTheme } from "next-themes";

const ProfileDropDown = ({ collapsed }: { collapsed: boolean }) => {
  const navigate = useNavigate();
  const { theme, setTheme } = useTheme();

  const handleLogout = () => {
    navigate("/logout");
  };

  const user = getUser();

  return (
    <div
      className={`dropdown dropdown-top w-full ${
        collapsed ? "dropdown-right" : "dropdown-center"
      }`}
    >
      {/* Profile Card Trigger */}
      <div
        tabIndex={0}
        role="button"
        className={`w-full p-2 hover:bg-base-300 transition-colors rounded-lg flex items-center gap-3 ${
          collapsed ? "justify-center" : ""
        }`}
      >
        {/* Avatar */}
        <div className="avatar">
          <div className="w-8 h-8 rounded-lg">
            {user?.profile_pic ? (
              <img src={user.profile_pic} alt="Profile" />
            ) : (
              <div className="w-full h-full bg-base-100 flex items-center justify-center rounded-lg text-sm font-semibold">
                {user?.email?.[0]?.toUpperCase() || "U"}
              </div>
            )}
          </div>
        </div>
        {/* Email (only when not collapsed) */}
        {!collapsed && (
          <span className="text-sm font-medium truncate flex-1 text-left">
            {user?.email}
          </span>
        )}
      </div>

      {/* Profile Dropdown Content */}
      <div
        tabIndex={0}
        className="dropdown-content card card-compact bg-base-100 z-[1] w-64 shadow-lg"
      >
        <div className="card-body p-2">
          {/* Theme Dropdown */}
          <div className="dropdown dropdown-end">
            <div
              tabIndex={0}
              role="button"
              className="flex items-center justify-between gap-3 w-full p-2 hover:bg-base-300 rounded"
            >
              <div className="flex items-center gap-3">
                <LuSunMoon size={16} />
                <span>Theme</span>
              </div>
              <LuChevronRight size={14} />
            </div>
            <div
              tabIndex={0}
              className="dropdown-content card card-compact bg-base-100 z-[1] w-32 shadow-lg"
            >
              <div className="card-body p-1">
                <input
                  type="radio"
                  name="theme-dropdown"
                  className="btn btn-sm btn-block btn-ghost justify-start"
                  aria-label="Light"
                  value="light"
                  checked={theme === "light"}
                  onChange={() => setTheme("light")}
                />
                <input
                  type="radio"
                  name="theme-dropdown"
                  className="btn btn-sm btn-block btn-ghost justify-start"
                  aria-label="Dark"
                  value="dark"
                  checked={theme === "dark"}
                  onChange={() => setTheme("dark")}
                />
              </div>
            </div>
          </div>

          {/* Logout */}
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 w-full p-2 hover:bg-base-300 rounded"
          >
            <MdOutlineLogout size={16} />
            <span>Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileDropDown;
